export default __webpack_public_path__ + "static/media/1213 cutlery top.f1574fe0.png";